import styled from 'styled-components';
import { TextInput } from '../../baseInputs/TextInput';
import { useScene } from '../../../../context/sceneContext';

export const HrefVariableInput = () => {
  const scene = useScene();

  const updateHref = (value?: string) =>
    scene.updateSelectedElementsData({ href: value }, 'props', 'hrefVariableInput');

  const data = scene.getSelectedElementsData({ href: undefined }, 'props');

  return (
    <Row>
      <TextInput label="URL" value={data.href} onChange={(newValue) => updateHref(newValue)} />
    </Row>
  );
};

const Row = styled.div`
  width: 100%;
  display: flex;
`;
